import { cn } from '../../lib/utils';

const sizeMap = { xs: 12, sm: 16, md: 20, lg: 28, xl: 40 } as const;

export default function Spinner({
  size = 20,
  className,
}: {
  size?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}) {
  const px = typeof size === 'number' ? size : sizeMap[size];
  return (
    <svg
      className={cn('animate-spin text-accent', className)}
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}
